<template>
    <v-container fluid>
      <v-card>
        <v-toolbar color="secondary" flat>
          <v-toolbar-title>New Account Category</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" small text to="/account-categories">
            <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- editor -->
            <editor :initial="dataItem" @data="save"></editor>
          <!-- end -->
        </v-card-text>
      </v-card>

      <snackbar ref="snackbar"></snackbar>
    </v-container>
</template>

<script>
import Editor from '../_components/editor.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    Editor
  },
  computed: {
    ...mapGetters(['user'])
  },
  data: () => ({
    dataItem: {}
  }),
  methods: {
     save(data) {
      const url = "/account-categories";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.$router.push('/account-categories');
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    }
  }
};
</script>